import apiClient from "../api/client";

/**
 * Download a CSV export from the given URL and trigger a browser file download.
 *
 * The generated Orval export hooks are query hooks that don't support blob
 * responses, so this imperative helper is used instead. Pair with
 * getExportOrgAuditLogsUrl / getExportSystemAuditLogsUrl from the generated
 * client to build the URL with query params.
 */
export const exportAuditLogsCsv = async (
  url: string,
  filename: string,
): Promise<void> => {
  const response = await apiClient.get(url, { responseType: "blob" });

  const blob = new Blob([response.data], { type: "text/csv" });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};
